import { Monitor, ArrowLeft, Shield, ExternalLink } from 'lucide-react';
import { useState } from 'react';

/**
 * DemoPage — Gate de senha + redirect para o demo Firebase Hosting.
 * Senha: aluno102030 (mesma do Mission Control)
 */

const DEMO_PASS = 'aluno102030';
const GATE_KEY = 'ac_demo_unlocked';

// URL do site demo no Firebase Hosting (segundo site)
const DEMO_SITE_URL = 'https://aluno-conectado-demo.web.app';

export function DemoPage() {
  const alreadyUnlocked = sessionStorage.getItem(GATE_KEY) === '1';
  const [unlocked, setUnlocked] = useState(alreadyUnlocked);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  function handleUnlock() {
    if (password === DEMO_PASS) {
      sessionStorage.setItem(GATE_KEY, '1');
      setUnlocked(true);
    } else {
      setError('Senha incorreta');
      setPassword('');
      setTimeout(() => setError(''), 2000);
    }
  }

  // ═══ Tela de Senha ═══
  if (!unlocked) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#050a14', color: 'white', fontFamily: "'Inter', sans-serif" }}>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'radial-gradient(circle at 50% 30%, rgba(99,102,241,.08) 0%, transparent 60%)', pointerEvents: 'none' }} />

        <div style={{ position: 'relative', zIndex: 1, textAlign: 'center', maxWidth: 400, width: '90%', padding: '48px 40px', background: 'rgba(15,31,58,.8)', backdropFilter: 'blur(16px)', border: '1px solid rgba(255,255,255,.08)', borderRadius: 20, boxShadow: '0 20px 60px rgba(0,0,0,.5)' }}>
          <div style={{ width: 64, height: 64, borderRadius: 16, background: 'rgba(99,102,241,.1)', border: '1px solid rgba(99,102,241,.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
            <Shield size={28} style={{ color: '#818cf8' }} />
          </div>

          <h2 style={{ fontSize: '1.3rem', fontWeight: 800, margin: '0 0 6px' }}>
            Demo <span style={{ background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Experience</span>
          </h2>
          <p style={{ fontSize: '.82rem', color: 'rgba(255,255,255,.4)', margin: '0 0 28px' }}>
            Acesso restrito. Informe a senha para acessar a demonstracao.
          </p>

          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleUnlock()}
            placeholder="••••••••••"
            autoFocus
            style={{
              width: '100%', padding: '12px 16px', borderRadius: 12,
              border: `1px solid ${error ? '#ef4444' : 'rgba(255,255,255,.12)'}`,
              background: 'rgba(0,0,0,.4)', color: 'white', fontSize: '.95rem',
              fontFamily: "'JetBrains Mono', monospace", textAlign: 'center',
              letterSpacing: 3, outline: 'none', boxSizing: 'border-box',
              transition: 'border-color .3s',
            }}
          />

          <div style={{ color: '#ef4444', fontSize: '.78rem', marginTop: 8, minHeight: 20 }}>{error}</div>

          <button
            onClick={handleUnlock}
            style={{
              marginTop: 16, width: '100%', padding: 12, borderRadius: 12,
              background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', color: 'white',
              fontWeight: 700, fontSize: '.9rem', border: 'none', cursor: 'pointer',
              transition: 'transform .2s',
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; }}
          >
            Acessar Demo
          </button>

          <a href="/" style={{ display: 'block', color: 'rgba(255,255,255,.3)', fontSize: '.78rem', marginTop: 20, textDecoration: 'none' }}>
            &larr; Voltar ao site
          </a>
        </div>
      </div>
    );
  }

  // ═══ Conteudo desbloqueado ═══
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #0f172a 100%)', color: 'white', fontFamily: "'Inter', sans-serif" }}>
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'radial-gradient(circle at 50% 30%, rgba(99,102,241,.1) 0%, transparent 60%)', pointerEvents: 'none' }} />

      <div style={{ position: 'relative', zIndex: 1, textAlign: 'center', maxWidth: 580, padding: '0 24px' }}>
        <div style={{ width: 80, height: 80, borderRadius: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(99,102,241,.1)', border: '1px solid rgba(99,102,241,.2)', margin: '0 auto 28px' }}>
          <Monitor size={36} style={{ color: '#818cf8' }} />
        </div>

        <h1 style={{ fontSize: '2rem', fontWeight: 900, margin: '0 0 12px' }}>
          Aluno <span style={{ background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Conectado</span> Experience
        </h1>

        <p style={{ fontSize: '1rem', color: 'rgba(255,255,255,.45)', lineHeight: 1.6, margin: '0 0 36px' }}>
          Demonstracao interativa completa da plataforma com banco de dados embutido e simulacao em tempo real.
        </p>

        <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
          <a href={DEMO_SITE_URL} target="_blank" rel="noopener noreferrer" style={{
            display: 'inline-flex', alignItems: 'center', gap: 10, padding: '14px 32px', borderRadius: 14,
            background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', color: 'white', fontWeight: 700,
            fontSize: '1rem', textDecoration: 'none', boxShadow: '0 0 30px rgba(99,102,241,.4)',
            transition: 'transform .2s, box-shadow .2s',
          }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 0 40px rgba(99,102,241,.6)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 0 30px rgba(99,102,241,.4)'; }}
          >
            <ExternalLink size={20} /> Abrir Demo no Navegador
          </a>

          <a href="/download" style={{
            display: 'inline-flex', alignItems: 'center', gap: 10, padding: '14px 32px', borderRadius: 14,
            background: 'rgba(255,255,255,.06)', color: 'white', fontWeight: 600,
            fontSize: '1rem', textDecoration: 'none', border: '1px solid rgba(255,255,255,.1)',
            transition: 'background .2s',
          }}
            onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,.1)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,.06)'; }}
          >
            Baixar Windows (.exe)
          </a>
        </div>

        <div style={{ marginTop: 40, padding: '16px 20px', borderRadius: 12, background: 'rgba(255,255,255,.03)', border: '1px solid rgba(255,255,255,.06)', textAlign: 'left' }}>
          <p style={{ fontSize: '.82rem', color: 'rgba(255,255,255,.4)', margin: 0, lineHeight: 1.6 }}>
            <strong style={{ color: 'rgba(255,255,255,.6)' }}>Nota:</strong> O demo web requer headers COEP/COOP para o WebContainer. Ele abre em uma nova aba com o ambiente completo (NestJS + PostgreSQL + React) rodando 100% no seu navegador.
          </p>
        </div>

        <a href="/" style={{ display: 'block', color: 'rgba(255,255,255,.25)', fontSize: '.78rem', marginTop: 24, textDecoration: 'none' }}>
          <ArrowLeft size={12} style={{ display: 'inline', verticalAlign: 'middle', marginRight: 4 }} />
          Voltar ao site principal
        </a>
      </div>
    </div>
  );
}
